var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.35352 5.14631L3.35352 0.146446C3.15829 -0.0488208 2.84169 -0.0488208 2.64642 0.146479C2.45119 0.341746 2.45119 0.658313 2.64645 0.853579L7.29289 5.49991L2.64642 10.1465C2.45119 10.3417 2.45119 10.6583 2.64645 10.8536C2.74405 10.9512 2.87202 11 2.99999 11C3.12795 11 3.25592 10.9512 3.35355 10.8535L8.35352 5.85341C8.44732 5.75965 8.49999 5.63248 8.49999 5.49988C8.49999 5.36728 8.44732 5.24008 8.35352 5.14631Z",
    fill: "#8B8CA7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.7d754901b1c72d926fa981b0b9a8ca45.svg";
export { ForwardRef as ReactComponent };